export const PROJECT_STAGES = [
  'Advance Payment Done',
  'Advance Payment -- Approvals / First Payment',
  'Approvals -- Loan Applications',
  'Loan Started -- Loan Process',
  'Loan Approved / First Payment Collected -- Material Order',
  'Materials Ordered -- Materials Deliver',
  'Materials Delivered -- Installation',
  'Installation Done / Second Payment Done -- Net meter Application',
  'Net Meter Application -- Net Meter Installation',
  'Net Meter Installed -- Inspection / Final Payment',
  'Approved Inspection -- Subsidy in Progress',
  'Subsidy Disbursed -- Final payment',
  'Final Payment Done'
];

export const CHITOOR_PROJECT_STAGES = [
  'Pending',
  'In Progress',
  'Material Pending',
  'Material Sent',
  'Installation Completed',
  'Completed',
  'On Hold'
];
